import { Typography } from "components/common";
import {
  StyledCurrentMonitorContainer,
  StyledDialogContentContainer,
  StyledLi,
  StyledMonitorSubmittedTextContainer,
  StyledUl,
} from "components/monitorManagement/MonitorCheckResultContent/styled";
import { DisplayMonitor } from "pages/MonitorManagement/hook";
import React from "react";
import { MonitorCheckResult } from "types/graphqlapi";

type MonitorCheckResultDisplayType = {
  monitorCheckResult: MonitorCheckResult;
  monitor: DisplayMonitor;
};

export const MonitorCheckResultDisplay: React.FC<
  MonitorCheckResultDisplayType
> = ({ monitorCheckResult, monitor }) => {
  return (
    <>
      <StyledDialogContentContainer>
        <StyledCurrentMonitorContainer>
          <Typography text="確認時の登録属性" />
          <StyledUl>
            {monitorCheckResult.initial_name && (
              <StyledLi>名前：{monitorCheckResult.initial_name}</StyledLi>
            )}
            {monitorCheckResult.initial_sex && (
              <StyledLi>性別：{monitorCheckResult.initial_sex}</StyledLi>
            )}
            {monitorCheckResult.initial_age && (
              <StyledLi>年齢：{monitorCheckResult.initial_age}</StyledLi>
            )}
            {monitorCheckResult.initial_address && (
              <StyledLi>居住地：{monitorCheckResult.initial_address}</StyledLi>
            )}
            {monitorCheckResult.initial_marriage && (
              <StyledLi>未既婚：{monitorCheckResult.initial_marriage}</StyledLi>
            )}
            {monitorCheckResult.initial_children && (
              <StyledLi>子有無：{monitorCheckResult.initial_children}</StyledLi>
            )}
            {monitorCheckResult.initial_job && (
              <StyledLi>職業：{monitorCheckResult.initial_job}</StyledLi>
            )}
          </StyledUl>
        </StyledCurrentMonitorContainer>
        <StyledCurrentMonitorContainer>
          <Typography text="現在の登録属性" />
          <StyledUl>
            {monitor.name && <StyledLi>名前：{monitor.name}</StyledLi>}
            {monitor.sex && <StyledLi>性別：{monitor.sex}</StyledLi>}
            {monitor.age && <StyledLi>年齢：{monitor.age}</StyledLi>}
            {monitor.address && <StyledLi>居住地：{monitor.address}</StyledLi>}
            {monitor.marriage && (
              <StyledLi>未既婚：{monitor.marriage}</StyledLi>
            )}
            {monitor.children && (
              <StyledLi>子有無：{monitor.children}</StyledLi>
            )}
            {monitor.job && <StyledLi>職業：{monitor.job}</StyledLi>}
          </StyledUl>
        </StyledCurrentMonitorContainer>
        <StyledMonitorSubmittedTextContainer>
          <Typography text="モニター回答" />
          <Typography
            text={
              monitorCheckResult.submitted_text
                ? monitorCheckResult.submitted_text
                : ""
            }
          />
        </StyledMonitorSubmittedTextContainer>
      </StyledDialogContentContainer>
    </>
  );
};
